<template>
  <div></div>
</template>

<script>
import detectFocusChange from "@/mixins/detectFocusChange";
import { serverTimestamp } from "@/utils/firebase-helper";

export default {
  name: "GameFocus",

  props: ["focusRef"],

  mixins: [detectFocusChange],

  data() {
    return {};
  },

  watch: {
    async tabFocus(value) {
      if (!this.focusRef) return;

      this.focusRef.add({
        tabFocus: value,
        timestamp: serverTimestamp(),
      });
    },
  },
};
</script>

<style></style>
